import _StatefulBase from '../_StatefulBase/_StatefulBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ResourcePicker.html?raw';
import on from 'dojo/on';
import domConstruct from 'dojo/dom-construct';
import { ColorHelpers } from "../../../more/Helpers";



interface dndConfig {
    groupDropReceivedCallback?: (data: ResourcePicker.DragDropProcessData<ResourcePicker.GroupDescriptor>) => ResourcePicker.DragDropResultItem,
    groupEnableDropCallback?: (data: ResourcePicker.DragDropProcessData<ResourcePicker.GroupDescriptor>) => boolean,
    itemEnableDragCallback?: (data: ResourcePicker.DragDropProcessData<ResourcePicker.ResourceEntry>) => boolean,
    itemEnableDropCallback?: (data: ResourcePicker.DragDropProcessData<ResourcePicker.ResourceEntry>) => boolean,
    itemDroppedCallback?: (data: ResourcePicker.DragDropProcessData<ResourcePicker.ResourceEntry>) => boolean,
}
class ResourcePicker extends compose(_StatefulBase) {
    templateString: any = template;

    tableContainer: HTMLDivElement;

    //groupingKey: string = null; //key für th spalte (bsp Date)
    //dataKey: string = null; //key für selectable data
    private configuration: ResourcePicker.ResourcePickerConfiguration;
    private items: Array<ResourcePicker.ResourceEntry> = [];

    private tooltipCallback: Function = null;

    private minSelectedIndex: number = -1;
    private maxSelectedIndex: number = -1;

    //multiSelect: boolean = true; //multiselect allowed?
    //showTooltip: boolean = true; //show tooltips? (need "tooltip" property in data)

    private groupRegistry: Array<ResourcePicker.GroupDescriptor> = []; //groups (for tableheaders)
    private createdItemNodes: Array<HTMLElement> = []; //nodeRegistry (for selectItem)

    private theadRow: HTMLElement = null;
    private tbodyRow: HTMLElement = null;

    protected allowDrag: boolean = false;

    public hideItem(itemValue: string, unHide: boolean = false) {
        let item = this.getItemByValue(itemValue);

        if (item && !unHide) {
            this.UiModder.domClass.add(item.node, "w3-hide");
        }
    }

    private _createTable() {

        this.UiModder.domConstruct.empty(this.tableContainer);

        if (!this.groupRegistry?.length) {
            this.UiModder.domConstruct.create("p", { "innerHTML": this.translate("General__NoEntries"), "className": "mediumBrightTransparentBG padding round italic secondaryTXT" }, this.tableContainer);
            return;
        }

        //create table
        let table = this.UiModder.domConstruct.create("table", { className: "", style: "width: 100%" }, this.tableContainer);
        // HINWEIS: table-node ist absichtlich auf 100% Breite gestyled (redundant zu Stylesheet!), weil sonst die initiale Breitenanpassung fehlschlagen kann!

        let thead = this.UiModder.domConstruct.create("thead", null, table, "first")
        let tbody = this.UiModder.domConstruct.create("tbody", null, table, "last")
        let thRow = this.UiModder.domConstruct.create("tr", {
            className: "headrow"
        }, thead, "first");
        let tbRow = this.UiModder.domConstruct.create("tr", {
            className: "contentrow"
        }, tbody, "last")
        let index = 0;

        this.theadRow = thRow;
        this.tbodyRow = tbRow;

        this.groupRegistry.forEach(lang.hitch(this, this.constructGroupHeader));

        //let item = this.getItemByValue(this.configuration.scrollToTarget);
        //item.node.scrollIntoView({ behavior: "smooth", block: "center" });

        if (this.configuration.scrollToTarget) {
            setTimeout(lang.hitch(this, function () {
                let item = this.getItemByValue(this.configuration.scrollToTarget);

                if (item && item.node) {
                    item.node.scrollIntoView({ behavior: "smooth", block: "center" });
                    this.configuration.scrollToTarget = null;
                }
            }), 250);
            
        }  

        this.emit("tableCreated");
    }

    adjustHeightFactorToContent(maxHeightFactor: number, stepWidth: number = 0.02) {
        if (stepWidth <= 0) return;
        if (maxHeightFactor <= 0) return;

        //console.trace("adjustHeightFactorToContent");

        for (let item of this.items) {
            try {
                let mainHeight = 0;
                if (item.mainLabelNode) {
                    mainHeight = mainHeight + item.mainLabelNode.getBoundingClientRect().height;
                }

                if (item.secondaryLabelNode) {
                    mainHeight = mainHeight + item.secondaryLabelNode.getBoundingClientRect().height;
                }

                if (item.draggingNode) {
                    mainHeight = mainHeight + item.draggingNode.getBoundingClientRect().height;
                }

                if (item.node) {
                    let displayedHeight = item.node.getBoundingClientRect().height;

                    while (mainHeight > displayedHeight && (maxHeightFactor > this._heightFactor)) {
                        this.setBaseUnits(this._widthFactor, this._heightFactor + stepWidth, this._baseUnit);
                        displayedHeight = item.node.getBoundingClientRect().height;
                    }
                }
                else {
                    console.warn(this.id + " adjustHeightFactor: item without node: propably no assignment to group!", item)
                }
            } catch (ex) {
                console.warn(this.id + " adjustHeightFactor for item failed!", item, ex)
            }
        }

    }

    private _onDragEnter_ResourceContainer(group: ResourcePicker.GroupDescriptor, evt: DragEvent) {
        if (!group) return;
        let result = true;

        if (this._dndConfig) {
            result = false;
            if (group.groupValue == this._currentDndItem.groupValue) {
                // es ist bereits die eigene Gruppe...
            }
            else if (this._dndConfig.groupEnableDropCallback) {
                try {
                    result = this._dndConfig.groupEnableDropCallback({
                        item: group,
                        draggedNode: this._currentDndItemNode,
                        dndPhase: "dragover",
                        event: evt
                    });
                } catch (ex) {
                    console.warn(this.id + " _onDragEnter_ResourceContainer: groupEnableDropCallback failed", ex);
                    result = false;
                }
            }
        }

        //console.debug(this.id + " _onDragEnter_ResourceContainer", result, group.label, evt);

        this.UiModder.domClass.toggle(group.contentNode, "dragover", result);
        this.UiModder.domClass.toggle(group.headerNode, "dragover", result);
        
    }
    private _onDragLeave_ResourceContainer(group: ResourcePicker.GroupDescriptor, evt: DragEvent) {
        if (!group) return;
        //console.debug(this.id + " _onDragLeave_ResourceContainer", group.label, evt);

        this.UiModder.domClass.remove(group.contentNode, "dragover");
        this.UiModder.domClass.remove(group.headerNode, "dragover");
        
    }

    private _onDragOver_ResourceContainer(group: ResourcePicker.GroupDescriptor, evt: DragEvent) {
        if (!group) return;
        //console.debug(this.id + " _onDragOver_ResourceContainer", group.label, evt);
        let result = true;


        if (this._dndConfig) {
            result = false;
            if (this._dndConfig.groupEnableDropCallback) {
                try {
                    result = this._dndConfig.groupEnableDropCallback({
                        item: group,
                        draggedNode: this._currentDndItemNode,
                        dndPhase: "dragover",
                        event: evt
                    });
                } catch (ex) {
                    result = false;
                }
            }
        }

        this.UiModder.domClass.toggle(group.contentNode, "dragover", result);
        this.UiModder.domClass.toggle(group.headerNode, "dragover", result);


        if (result === true) {
            evt.preventDefault();
        }
    }
    private _onDrop_ResourceContainer(group: ResourcePicker.GroupDescriptor, evt: DragEvent) {

        // es wurde was auf eine Gruppe gedroppt
        // wir wissen nicht was es ist, kann jegliche Node sein
        // wir wissen nur die Gruppe als Ziel

        console.log(this.id + " _onDrop_ResourceContainer", group, evt);
        let result: ResourcePicker.DragDropResultItem<any> = null;


        if (this._dndConfig) {
            if (this._dndConfig.groupDropReceivedCallback) {
                try {
                    result = this._dndConfig.groupDropReceivedCallback({
                        item: group,
                        draggedNode: this._currentDndItemNode,
                        dndPhase: "drop",
                        event: evt
                    });
                } catch (ex) {
                    console.warn("DND Drop on Group failed", group, ex)
                    result = null;
                }
            }
        }


        if (result) {
            evt.preventDefault();
            this.updateItem(result.newEntryData)
        }

        this.UiModder.domClass.remove(group.contentNode, "dragover");
        this.UiModder.domClass.remove(group.headerNode, "dragover");


        this._currentDndItem = null;
        this._currentDndItemNode = null;

        
    }

    updateItem(newItemData: ResourcePicker.ResourceEntry_Stump) {
        if (newItemData && newItemData.value) {
           
            let udpatedItem = this.getItemByValue(newItemData.value);
            if (udpatedItem) {
                for (let key in newItemData) {
                    udpatedItem[key] = newItemData[key];
                }
            } else {
                this.items.push({
                    ...newItemData as any, // einige Properties werden ausgelassen und im creattable selber erzeugt
                });
            }
            this._createTable();
            ////(evt.target as HTMLElement)
            //let dragTarget = evt.target as HTMLElement;
            //if (dragTarget) {

            //    dragTarget.appendChild(this._lastDnDnode);
            //    this.hideNode(this._lastDnDnode);
            //}


        }
    }

    private constructGroupHeader(group: ResourcePicker.GroupDescriptor) { //iterate over group keys
        let thRow: HTMLElement = this.theadRow;
        let tbRow: HTMLElement = this.tbodyRow;
        //let groupData: ResourcePicker.GroupDescriptor = this.tableHeaderRegistry[groupValue]; //get access of Object of the group (additional info for group)
        //create th & td of current group
        let th = this.UiModder.domConstruct.create("th", {className: "groupHead" }, thRow);
        let ghSplitContainer = this.UiModder.domConstruct.create("div", {className: "splitContainer" }, th);
        let ghMainContainer = this.UiModder.domConstruct.create("div", { className: "mainContainer" }, ghSplitContainer);
        let label = this.UiModder.domConstruct.create("div", {
            innerHTML: group.label,
            className: "mainLabel"
        }, ghMainContainer);
        let td = this.UiModder.domConstruct.create("td", null, tbRow);
        let groupContainer = this.UiModder.domConstruct.create("div", {
            className: "resourceContainer",
            //innerHTML: "no resources"
        }, td);

        
        if (group.secondaryLabel) {
            this.UiModder.domConstruct.create("div", { innerHTML: group.secondaryLabel, className: "secondaryLabel" }, ghMainContainer);
        }

        //let itemsContainer = this.UiModder.domConstruct.create("div", {
        //    className: "itemsContainer"
        //}, td);

        this.UiModder.domAttr.set(td, "groupValue", group.groupValue);
        this.UiModder.domAttr.set(groupContainer, "groupLabel", group.label);

        if (group.widthfactor) {
            let widthStyle = "calc(var(--widthFactor) * " + group.widthfactor.toString() + " * var(--sizeBaseUnit))";
            this.UiModder.domStyle.set(th, "width", widthStyle);
            this.UiModder.domStyle.set(td, "width", widthStyle);
            //this.UiModder.domStyle.set(itemsContainer, "width", widthStyle);
        }

        this.UiModder.domClass.add(groupContainer, "emptyGroup");


        // Platzhalter für leere Gruppe, damit was drinsteht
        if (this.configuration.labelEmptyGroupContent !== false) {
            //this.UiModder.domConstruct.create("div", {
            //    innerHTML: this.translations["General__NoEntries"], className: "emptyGroup"
            //}, div);

            //div.style.setProperty("--emptyLabel", this.translations["General__NoEntries"]);
            this.UiModder.domAttr.set(groupContainer, "emptyLabel", this.translate("General__NoEntries"));

        }

        group.contentNode = groupContainer;
        group.headerNode = th;
        group.items = [];

        let mobileContainer = this.UiModder.domConstruct.create("div", { "className": "mobileHeader" }, group.contentNode);
        let mobileSplit = this.UiModder.domConstruct.create("div", { className: "splitContainer" }, mobileContainer);
        group.mobileHeaderNode = mobileContainer;

        let mainClone = lang.clone(ghMainContainer);
        this.UiModder.domConstruct.place(mainClone, mobileSplit);


        if (group.tooltip) {

            let ghOverflowContainer = this.UiModder.domConstruct.create("div", { className: "overflowContainer" }, group.headerNode);

            let icon = this._createTooltipIcon(ghSplitContainer, group.tooltip, group);
            this._createTooltipIcon(mobileSplit, group.tooltip, group);
            //this.UiModder.domClass.add(th, "clickableTooltip");

            let tooltip = this.UiModder.domConstruct.create("div", {
                className: "tooltiptext",
                innerHTML: group.tooltip
            }, ghOverflowContainer);
        }

        if (group.colorBG) {
            this.UiModder.domClass.add(group.headerNode, "customColor");
            this.UiModder.domClass.add(group.mobileHeaderNode, "customColor");
            group.headerNode.style.setProperty("--bgColor", group.colorBG);
            group.mobileHeaderNode.style.setProperty("--bgColor", group.colorBG);
            if (!group.colorTXT) {
                let bgColorHex = ColorHelpers.getHexColorFromProperty(group.colorBG);
                if (bgColorHex) {
                    if (ColorHelpers.isDarkColor(bgColorHex) === true) {
                        this.UiModder.domClass.add(group.headerNode, "darkBG");
                        this.UiModder.domClass.add(group.mobileHeaderNode, "darkBG");
                    }
                }
            }
        }
        if (group.colorTXT) {
            //this.UiModder.domStyle.set(group.headerNode, "color", group.colorTXT);
            //this.UiModder.domStyle.set(group.mobileHeaderNode, "color", group.colorTXT);
            this.UiModder.domClass.add(group.headerNode, "customColor");
            group.headerNode.style.setProperty("--txtColor", group.colorTXT);
            group.mobileHeaderNode.style.setProperty("--txtColor", group.colorTXT);
        }


        let expanderBtn = this.UiModder.domConstruct.create("button", {
            "className": "expanderButton mds-button-base",
            "innerHTML": ""
        }, mobileContainer.firstChild);
        let expanderIcon = this.UiModder.domConstruct.create("i", {
            "className": "fas fa-caret-down",
            "innerHTML": ""
        }, expanderBtn);

        //on(expanderBtn, "click", lang.hitch(this, this._onClick_Expander, group, expanderIcon));
        on(mobileContainer, "click", lang.hitch(this, this._onClick_Expander, group, expanderIcon));

        //check if group is blocked
        if (group.blocked) {
            //create a "blocked" element for current group
            //let div = this.UiModder.domConstruct.create("div", null, td);
            this.UiModder.domClass.remove(group.contentNode, "emptyGroup");
            let blockContainer = this.UiModder.domConstruct.create("div", {
                innerHTML: group.blockLabel, className: "blockedGroup"
            }, group.contentNode);

            this.UiModder.domClass.add(mainClone, "blocked");

        } else {

            if (this.allowDrag) {
                group.headerNode.setAttribute("data-group-value", group.groupValue);
                group.mobileHeaderNode.setAttribute("data-group-value", group.groupValue);
                group.contentNode.setAttribute("data-group-value", group.groupValue);

                on(groupContainer, "dragenter", lang.hitch(this, this._onDragEnter_ResourceContainer, group));
                on(groupContainer, "dragleave", lang.hitch(this, this._onDragLeave_ResourceContainer, group));
                on(groupContainer, "dragover", lang.hitch(this, this._onDragOver_ResourceContainer, group));
                on(groupContainer, "drop", lang.hitch(this, this._onDrop_ResourceContainer, group));
            }


            //create selectable Items in TD
            let filteredItems = this.getItemsByGroupValue(group.groupValue);
            for (let item of filteredItems) {
                this.placeItemInGroup(item, group);
            }
        }
    }

    //private _onClick_GroupTooltip(group: ResourcePicker.GroupDescriptor, evt?: MouseEvent) {
    //    //console.debug("_onClick_GroupResourceContainer", group, bTarget, evt);
        
    //    if (evt) {
    //        if (evt.target == group.headerNode || evt.target == group.mobileHeaderNode) {
    //            this.UiModder.domClass.toggle(group.headerNode, "showTooltip");
    //            this.UiModder.domClass.toggle(group.mobileHeaderNode, "showTooltip");
    //            evt.stopPropagation();

    //            for (let group of this.groupRegistry) {
    //                if (group.headerNode != evt.target && group.mobileHeaderNode != evt.target) {
    //                    this.UiModder.domClass.remove(group.headerNode, "showTooltip");
    //                    this.UiModder.domClass.remove(group.mobileHeaderNode, "showTooltip");
    //                }
    //            }

    //        } 
    //    } else {
    //        this.UiModder.domClass.toggle(group.headerNode, "showTooltip", false);
    //        this.UiModder.domClass.toggle(group.mobileHeaderNode, "showTooltip", false);
    //    }
    //}

    getGroupByValue(value: string, bReturnBlocked: boolean = false): ResourcePicker.GroupDescriptor {
        for (let group of this.groupRegistry) {
            if (group.groupValue == value) {
                if (group.blocked != true || bReturnBlocked === true) {
                    return group;
                }
                break;
            }
        }
        return null;
    }

    scrollTo(itemOrGroupValue: string): boolean {
        if (this.scrollToItem(itemOrGroupValue) == true) return true;
        if (this.scrollToGroup(itemOrGroupValue) == true) return true;
        return false;
    }

    scrollToGroup(value: string): boolean {
        // Achtung: scrollTo funktioniert nur, wenn die node nicht irgendwo versteckt ist. ansonsten ist offsetLeft und offsetTop immer 0.

        if (!value) return false;
        let group = this.getGroupByValue(value);
        if (group?.headerNode) {

            //group.headerNode.scrollIntoView({ behavior: "auto", block: "nearest", inline: "start" });
            // alternativ, falls scrollIntoView nervt, weil es den Browser auch vertikal mitzieht:
            this.tableContainer.scrollTo({
                behavior: "auto",
                left: group.headerNode.offsetLeft, // falls mobil, ist offsetLeft 0. ansonsten != 0
                top: group.mobileHeaderNode.offsetTop // falls mobil, ist offsetTop != 0. ansonsten 0
            });// group.headerNode.offsetLeft, 0);

            return true;
        }

        return false;
    }

    scrollToItem(value: string): boolean {
        if (!value) return false;

        let item = this.getItemByValue(value);
        if (item?.node) {
            //item.node.scrollIntoView({ behavior: "auto", block: "nearest", inline: "start" });

            this.tableContainer.scrollTo({
                behavior: "auto",
                left: item.node.offsetLeft,
                top: item.node.offsetTop
            });// group.headerNode.offsetLeft, 0);


            return true;
        }
        //else if (!item) {
        //    // fallback:
        //    return this.scrollToGroup(value);
        //}

        return false;
    }

    getItemByValue(itemvalue: string, bReturnUnselectable: boolean = true): ResourcePicker.ResourceEntry {
        for (let item of this.items) {
            if (item.value == itemvalue) {
                return item;
            }
        }
        return null;
    }

    getItemsByGroupValue(value: string): Array<ResourcePicker.ResourceEntry> {
        let filterList = this.items.filter(item => item.groupValue == value);

        return filterList;
    }

    private getItemByGlobalIndex(index: number): ResourcePicker.ResourceEntry {
        let filterList = this.items.filter(item => item.globalIndex == index);

        if (filterList && filterList.length) {
            return filterList[0];
        }
        return null;
    }

    private getItemIndexInGroup(itemvalue: string, group: ResourcePicker.GroupDescriptor): number {
        let index = 0;
        for (let item of group.items) {
            index++;
            if (item.value == itemvalue) {
                return index;
            }
        }

        return -1;
    }

    private _onClick_Expander(group: ResourcePicker.GroupDescriptor, expanderIconNode: HTMLElement) {

        //if (!group.items?.length) return;

        this.UiModder.domClass.toggle(group.contentNode, "expanded");
        let state = this.UiModder.domClass.contains(group.contentNode, "expanded");
        this.UiModder.domClass.toggle(expanderIconNode, "fa-caret-down", !state);
        this.UiModder.domClass.toggle(expanderIconNode, "fa-caret-up", state);

        if (state === true) {
            let scrollTarget = this.getScrollTargetOfGroup(group);
            if (scrollTarget) {
                scrollTarget.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    }

    private getScrollTargetOfGroup(group: ResourcePicker.GroupDescriptor): HTMLElement {
        // es gibt ein nicht-standardmäßiges Feature aus JDM, das auch in der mobilen Ansicht Scrollen auslöst wenn eine
        // Gruppe aufgeklappt wird. das inzwischen mal quick & dirty übernehmen, ggf. wird das Flag später mal korrekt einfließen
        if (!group) return null;
        for (let item of group.items) {
            if (item["isScrollTarget"]) {
                return item.node;
            }
        }
    }

    private _currentDndItemNode: HTMLElement;
    private _currentDndItem: ResourcePicker.ResourceEntry;
    private _onDragStart_Item(item: ResourcePicker.ResourceEntry, evt: DragEvent) {
        //console.log("_onDragStart_Item", item);

        this.UiModder.domClass.add(item.node, "dragging");

        this._currentDndItemNode = evt.target as HTMLElement;
        this._currentDndItem = item;


        let emitData: ResourcePicker.DragDropProcessData<any> = {
            draggedNode: this._currentDndItemNode,
            item: this._currentDndItem,
            dndPhase: "dragstart"
        };

        //this.emit("dndInProgress", emitData);

       
    }

    private _onDragEnd_Item(item: ResourcePicker.ResourceEntry, evt: DragEvent) {
        //console.log("_onDragEnd_Item", item);

        this.UiModder.domClass.remove(item.node, "dragging");

        //this._lastDnDnode = null;
        //this._lastDnDItem = null;

        let emitData: ResourcePicker.DragDropProcessData<any> = {
            draggedNode: this._currentDndItemNode,
            item: this._currentDndItem,
            dndPhase: "dragend"
        };

        let result = true;
        if (this._dndConfig) {
            result = false;

            if (this._dndConfig.itemDroppedCallback) {
                try {
                    let result = this._dndConfig.itemDroppedCallback(emitData);
                } catch (ex) {
                    result = false;
                }

            }
        }

        
        if (result) {
            
        }


        //this.emit("dndInProgress", emitData);
    }

    private placeItemInGroup(item: ResourcePicker.ResourceEntry, group?: ResourcePicker.GroupDescriptor, bIgnoreBlockedGroup: boolean = false) {

        if (!group) {
            group = this.getGroupByValue(item.groupValue, bIgnoreBlockedGroup);
        }
        if (!group) {
            console.warn("item without group cannot be placed!", item, this.groupRegistry);
            return;
        }

        let index = this.createdItemNodes.length;
        // todo: und wenn ein Item nachträglich, weil unsortiert, in die Gruppe kommt?
        // dann müssen ja alle anderen Gruppen ihre Einträge nach hinten rutschen
        
        if (item.node) {
            let existingIndex = this.createdItemNodes.indexOf(item.node); // kann ja ned gehn oder?
            if (existingIndex >= 0) {
                this.createdItemNodes.splice(existingIndex, 1);
            }

            domConstruct.destroy(item.node);
            item.node = null;

            // todo: eigentlich müsste die Node jetzt aus den createdItemNodes raus
            // dann müssten die nachfolgenden Index aus der Gruppe verringert werden um 1
            // dann erhält die neue itemnode den Index vom vorher höchsten Eintrag in der Gruppe
            existingIndex = this.getItemIndexInGroup(item.value, group);
            let itemsOfGroup = this.getItemsByGroupValue(group.groupValue);

            if (existingIndex >= 0) {
                group.items.splice(existingIndex, 1);
            }

            for (let item of itemsOfGroup) {
                if (item.globalIndex >= existingIndex) {
                    index = item.globalIndex;
                    item.globalIndex--;                    
                }
            }
        }

        // contentnode einmal ausleeren, damit der "leer"-Platzhalter rauskommt!
        if (group.items.length == 0) {
            this.UiModder.domClass.remove(group.contentNode, "emptyGroup");
        }

       
        let itemNode = this.UiModder.domConstruct.create("div", {
            innerHTML: "",//,"<b>" + item.label + "<br></b>" + item.secondaryLabel,
            className: "item"
        }, group.contentNode);

        let draggingNode: HTMLElement = null;
        if (this.allowDrag) {
            itemNode.setAttribute("data-item-value", item.value);            

            on(itemNode, "dragstart", lang.hitch(this, this._onDragStart_Item, item));
            on(itemNode, "dragend", lang.hitch(this, this._onDragEnd_Item, item));

            draggingNode = this.UiModder.domConstruct.create("div", {
                className: "draggingNode"
            }, itemNode, "first");

            on(draggingNode, "click", lang.hitch(this, function (evt) { evt.stopPropagation(); }));
        }

        let splitContainer = this.UiModder.domConstruct.create("div", {
            innerHTML: "",//,"<b>" + item.label + "<br></b>" + item.secondaryLabel,
            className: "splitContainer"
        }, itemNode);
        let mainContainerNode = this.UiModder.domConstruct.create("div", {
            innerHTML: "",//,"<b>" + item.label + "<br></b>" + item.secondaryLabel,
            className: "mainContainer"
        }, splitContainer);

        let overflowContainer = this.UiModder.domConstruct.create("div", {
            innerHTML: "",//,"<b>" + item.label + "<br></b>" + item.secondaryLabel,
            className: "overflowContainer"
        }, itemNode);

        this.UiModder.domClass.add(itemNode, item.selectable ? "selectable" : "disabled");
        this.UiModder.domClass.toggle(itemNode, "occupied", item.occupied == true);
        this.UiModder.domClass.toggle(itemNode, "insivible", item.invisible == true);
        this.UiModder.domAttr.set(itemNode, "dataValue", item.value);

        if (item.colorBG) {
            this.UiModder.domClass.add(itemNode, "customBG");
            itemNode.style.setProperty("--bgColor", item.colorBG);
            if (!item.colorTXT) {
                let bgColorHex = ColorHelpers.getHexColorFromProperty(item.colorBG);
                if (bgColorHex) {
                    if (ColorHelpers.isDarkColor(bgColorHex) === true) {
                        this.UiModder.domClass.add(itemNode, "darkBG");
                    }
                }
            }
            //this.UiModder.domStyle.set(itemNode, "backgroundColor", item.colorBG);
        }

        if (item.colorTXT) {
            this.UiModder.domClass.add(itemNode, "customTXT");
            itemNode.style.setProperty("--txtColor", item.colorTXT);
            //this.UiModder.domStyle.set(itemNode, "color", item.colorTXT);
        }

        if (item.colorSecondary) {
            this.UiModder.domClass.add(itemNode, "secondaryColor");
            itemNode.style.setProperty("--secondaryColor", item.colorSecondary);
            
            //this.UiModder.domStyle.set(itemNode, "backgroundColor", item.colorBG);
        }



        // Größen setzen: für Höhe kann jedes Item einen Multiplikator mitbringen
        if (item.heightfactor) {
            // height: calc(var(--heightFactor) * var(--sizeBaseUnit));
            if (item.heightfactor != 1) {
                //debugger;
            }
            this.UiModder.domStyle.set(itemNode, "height", "calc(var(--heightFactor) * " + item.heightfactor.toString() + " * var(--sizeBaseUnit))")
        }
        //if (group.widthfactor) {
        //    let widthStyle = "calc(var(--widthFactor) * " + group.widthfactor.toString() + " * var(--sizeBaseUnit))";
        //    this.UiModder.domStyle.set(itemNode, "width", widthStyle);
        //}

        let label = this.UiModder.domConstruct.create("div", {
            innerHTML: item.label,
            "className": "mainLabel"
        }, mainContainerNode);

        let secondaryLabel = null;

        if (item.secondaryLabel) {
            secondaryLabel = this.UiModder.domConstruct.create("div", {
                innerHTML: item.secondaryLabel,
                "className": "secondaryLabel"
            }, mainContainerNode);
        }


        this.UiModder.domAttr.set(itemNode, "index", group.items.length);

        group.items.push(item);
        this.UiModder.domAttr.set(group.contentNode, "itemCount", group.items.length);
        this.UiModder.domClass.add(group.contentNode, "hasItems");

        item.node = itemNode;
        item.mainLabelNode = label;
        item.secondaryLabelNode = secondaryLabel;
        item.draggingNode = draggingNode;
        item.globalIndex = index;

        
        this.createdItemNodes.push(item.node);


        this.UiModder.domAttr.set(itemNode, "index", item.globalIndex);

        if (this.configuration.enableTooltips && item.tooltip) { //create Tooltip Span if Tooltips are activated
            //this.UiModder.domClass.add(div, "tooltip");
            this._createTooltipIcon(splitContainer, item.tooltip, item, true);
            
        }

        item.node = itemNode;
        on(itemNode, "click", lang.hitch(this, this._itemClick, item));


        // DND prüfen:
        let draggable = this.allowDrag;

        if (this._dndConfig && item.selectable) {
            draggable = false;

            if (this._dndConfig.itemEnableDragCallback) {
                try {
                    draggable = this._dndConfig.itemEnableDragCallback({
                        item: item,
                        draggedNode: item.node,
                        dndPhase: "checkdraggable"
                    });
                } catch (ex) {

                }
            }
        }
        if (draggable === true) this.UiModder.domAttr.set(itemNode, "draggable", true);



        if (item.selected) {
            this.selectItem(item, true, true);
        }
    }

    private _showTooltip(targetNode: HTMLElement, scroll: boolean, content: string, data: any, evt: MouseEvent, ) {
        
        let nodes = document.getElementsByClassName("showTooltip")

        if (typeof (this.tooltipCallback) == "function" && (content || data)) {
            this.tooltipCallback(data, content);
            if (evt) {
                evt.stopPropagation();
            }

            return;
        }

        
        if (!targetNode || !this.UiModder.domClass.contains(targetNode, "showTooltip")) {
            for (var i = 0; i < nodes.length; i++) {
                this.UiModder.domClass.remove(nodes[i], "showTooltip");
            }

            if (targetNode && scroll === true) {
                targetNode.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }

        if (targetNode) {
            this.UiModder.domClass.toggle(targetNode, "showTooltip");
        }
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
        } 
    }

    private _createTooltipIcon(targetNode: HTMLElement, content: string, data: any, scroll?: boolean): HTMLElement {
        let div = this.UiModder.domConstruct.create("div", {
            innerHTML: "<i class='fas fa-info'</i>",
            className: "tooltipIcon"
        }, targetNode, "first");

        let tooltip = this.UiModder.domConstruct.create("div", {
            className: "tooltiptext",
            innerHTML: ""
        }, div);
        this.UiModder.domAttr.set(tooltip, "innerHTML", content);

        on(div, "click", lang.hitch(this, this._showTooltip, div, scroll === true, content, data))
        //on(tooltip, "click", lang.hitch(this, this._showTooltip, tooltip))


        return div;
    }

    private deselectItem(item: ResourcePicker.ResourceEntry, bSuppressChangeEvent?: boolean) {
        this.selectItem(item, false, false, bSuppressChangeEvent);
    }

    private deselectIndex(index: number) {
        let item = this.getItemByGlobalIndex(index);

        this.selectItem(item, false);
    }

    private selectItem(item: ResourcePicker.ResourceEntry, bSelect: boolean = true, bForceIfUnselectable: boolean = false, bSuppressChangeEvent?: boolean) {
        //if (itemIndex == null || itemIndex < 0) return;
        if (!item) return;
        //let item = this.getEntryByGlobalIndex(itemIndex);

        if (item.selected === true || item.selectable === true || bForceIfUnselectable) {
            item.selected = bSelect;
        }
        for (let tmp of this.items) {
            if (tmp.node) {
                this.UiModder.domClass.remove(tmp.node, "first last");
            }
        }

        let group = this.getGroupByValue(item.groupValue);
        if (group) {
            
        }
        
        this.UiModder.domClass.toggle(item.node, "selected", item.selected);

        //this.selectedIndexes.sort((a, b) => a - b);
        let selectedItems = this._getSelectedItems();

        if (selectedItems.length) {
            this.maxSelectedIndex = selectedItems[selectedItems.length - 1].globalIndex;
            this.minSelectedIndex = selectedItems[0].globalIndex;
        } else {
            this.maxSelectedIndex = -1;
            this.minSelectedIndex = -1;
        }

        let firstItem = this.getItemByGlobalIndex(this.minSelectedIndex);
        let lastItem = this.getItemByGlobalIndex(this.maxSelectedIndex);

        //console.debug("item selected", bSelect, item, selectedItems, this.minSelectedIndex, this.maxSelectedIndex);
        if (bSuppressChangeEvent !== true) {
            this._delayEmitChange();
        }


        if (!firstItem) return;

        if (firstItem && lastItem && firstItem.globalIndex != lastItem.globalIndex) {
            this.UiModder.domClass.add(firstItem.node, "first");
            this.UiModder.domClass.add(lastItem.node, "last");
        }


    }

    private _getSelectedItems(): Array<ResourcePicker.ResourceEntry> {

        if (!this.items || !this.items.length) return [];

        let items = this.items.filter(item => item.selected == true);
        items.sort(function (a, b) { return a.globalIndex - b.globalIndex });

        return items;
    }



    private _itemClick(clickedItem: ResourcePicker.ResourceEntry) {
        //debugger;
        if (!clickedItem.selectable || clickedItem.invisible) {
            return;
        }

        // ist der Klick am Anfang oder am Ende der gewählten Range?
        if (this.minSelectedIndex != this.maxSelectedIndex) {
            // klickt an den Anfang der gewählten Range: deselektieren und raus, das geht IMMER, auch wenn nicht Multiselect
            if (clickedItem.globalIndex == this.minSelectedIndex) {
                this._deselectAll();
                return;
            }

            // klickt aufs Ende des bereits gewählten Bereichs?
            if (clickedItem.globalIndex == this.maxSelectedIndex) {
                this._deselectAll();
                return;
            }
        }

        else { // index ist gleich, also ist nur 1 Item selektiert
            
            if (clickedItem.globalIndex == this.minSelectedIndex) {
                // das geklickte Item ist das selektierte - deselektieren und raus
                this._deselectAll();
                return;
            }

            else if (!this.configuration.enableMultiselect) {
                // alles deselektieren, aber danach weiter:
                this._deselectAll();
            }
            //this.selectedIndexes.forEach(lang.hitch(this, this.deselectIndex))
            //selectedItems.forEach(lang.hitch(this, this.deselectItem))
        }

        //sets clicked item to selected/deselected
        let entriesOfSameGroup = [];
        let entriesOfOtherGroup = [];
        let selectedItems = this._getSelectedItems();

        for (let item of selectedItems) {
            if (item) {
                if (item.groupValue == clickedItem.groupValue) {
                    entriesOfSameGroup.push(item);
                } else {
                    entriesOfOtherGroup.push(item);
                }
            }
        }

        //let entriesOfSameGroup = this.selectedIndexes.filter(filterItem => filterItem.groupValue == clickedItem.groupValue);
        //let entriesOfOtherGroup = this.selectedIndexes.filter(filterItem => filterItem.groupValue != clickedItem.groupValue);

        if (this.configuration.enableMultiselect) {
            if (this.configuration.multiselectInOneGroupOnly === true) {

                if (entriesOfOtherGroup && entriesOfOtherGroup.length) {
                    for (let item of entriesOfOtherGroup) {
                        this.deselectItem(item);
                    }
                }
            }
        }

        this.selectItem(clickedItem, !clickedItem.selected);
        clickedItem.node.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });

        selectedItems = this._getSelectedItems();

        let firstItem = this.getItemByGlobalIndex(this.minSelectedIndex);
        let lastItem = this.getItemByGlobalIndex(this.maxSelectedIndex);

        if (!firstItem) return;        

        if (this.configuration.enableMultiselect
            && this.configuration.enableFillgaps) {

            if (selectedItems.length > 0
                && clickedItem.selected
            ) {
                this._fillSelectionGap(firstItem, clickedItem);
            } else if (!clickedItem.selected) {
                if (clickedItem.value != firstItem.value) {
                    this._fillSelectionGap(firstItem, clickedItem)
                } else {

                    this._deselectAll();
                }
            }
        }

        //console.debug("_itemClick finished", this._getSelectedItems())

        this.emit("itemSelected", clickedItem.value); //event?
    }

    private _emitHandle: any = null;
    private _delayEmitChange(timeout: number = 140) {
        if (this._emitHandle != null) {
            clearTimeout(this._emitHandle);
        }

        this._emitHandle = setTimeout(lang.hitch(this, this.emitChange), timeout);
    }

    private emitChange() {
        //console.log("selection changed", this.minSelectedIndex, this.maxSelectedIndex, this.getValue());
        this.emit("change", this.getValue());
    }

    getValue(bDisplayValues?: boolean): Array<string> {
        let items = this._getSelectedItems();

        let values = [];
        for (let item of items) {
            if (bDisplayValues === true) {
                values.push(item.label);
            }
            else {
                values.push(item.value);
            }           
        }

        return values;
    }


    _deselectAll(bSuppressChangeEvent?: boolean) {
        let selectedItems = this._getSelectedItems();
        for (let item of selectedItems) {
            this.deselectItem(item, bSuppressChangeEvent);
        }
    }

    private _fillSelectionGap(startItem: ResourcePicker.ResourceEntry, endItem: ResourcePicker.ResourceEntry) {
        let startNode = startItem.node;
        let endNode = endItem.node;

        let startIndex = startItem.globalIndex;// parseInt(this.UiModder.domAttr.get(startNode, "index"));
        let endIndex = endItem.globalIndex;// parseInt(this.UiModder.domAttr.get(endNode, "index"));

        if (startIndex > endIndex) { //revert if startindex = endIndex
            let tempIndex = startIndex;
            startIndex = endIndex;
            endIndex = tempIndex;
        }

        for (let item of this.items) {
            let currentIndex = item.globalIndex;
            let currentId = item.value;

            if (currentIndex >= startIndex && currentIndex <= endIndex) {
                if (item.selected != true) {
                    this.selectItem(item, true);
                }

            } else {
                if (item.selected === true) {
                    this.deselectItem(item);
                }
            }
        }
    }

    //_getSelected() {
    //    return this.items.filter(item => item.selected);
    //}
    setValue(newValue: string | Array<string>, suppressChangeEvent: boolean = false): void {

        this._deselectAll(suppressChangeEvent);
        if (typeof (newValue) == "string") {
            let item = this.getItemByValue(newValue);//.items.filter(item => item.groupValue == id);
            this.selectItem(item, true, false, suppressChangeEvent);
        }

        else if (newValue && newValue.length) {
            for (let id of newValue) {
                let item = this.getItemByValue(id);//.items.filter(item => item.groupValue == id);
                this.selectItem(item, true, false, suppressChangeEvent);
            }
        }

        this.validateInput();

    }

    protected customValidation(): boolean {
        let result: boolean = false;

        if (this.isMandatory != true) {
            result = true;
        }

        let values = this._value as Array<string>;

        result = values?.length >= 1;

        if (this.configuration?.multiselectInOneGroupOnly == true && result && values?.length) {
            let groupValues = [];
            for (let str of values) {
                let item = this.getItemByValue(str);

                if (groupValues.indexOf(item.groupValue) == -1) {
                    groupValues.push(item.groupValue);
                }

                if (groupValues.length > 1) {
                    result = false;
                    break;
                }
            }
        }

        return result;
    }

    setConfiguration(config: ResourcePicker.ResourcePickerConfiguration) {
        this.configuration = config;

        this.groupRegistry = config.groups
        this.items = config.entries;

        // zum Testen:
        //this.configuration.enableMultiselect = false;
        //this.configuration.enableFillgaps = true;
        //this.configuration.enableTooltips = true;
        //this.configuration.multiselectInOneGroupOnly = false;
        //


        this._createTable();
    }

    //setItems(items: Array<ResourcePicker.ResourceEntry>) {
    //    this._deselectAll;

    //    this.items = items;

    //    let index = 0;
    //    for (let item of this.items) {

    //        item.globalIndex = index;
    //        index++;
    //    }

    //}

    private _heightFactor: number = 1;
    private _widthFactor: number = 2.5;
    private _baseUnit: string = "60px";
    setBaseUnits(widthFactor: number = 2.5, heightFactor: number = 1, baseUnit: string = "60px", maxHeight?: string) {
        this.domNode.style.setProperty("--sizeBaseUnit", baseUnit);
        this.domNode.style.setProperty("--heightFactor", heightFactor.toString());
        this.domNode.style.setProperty("--widthFactor", widthFactor.toString());

        this._heightFactor = heightFactor;
        this._widthFactor = widthFactor;
        this._baseUnit = baseUnit;

        if (maxHeight) {
            this.setLayout(maxHeight);
        }
    }

    /**
     * Grundlayout anpassen: der Auswahlraster liegt in einem Container, dessen Höhe, Breite und Positionierung angepasst werden
     * Hinweis: Der Raster wird immer horizontal scrollen, wenn die Elemente zu viel oder zu breit sind. Der width-Parameter stellt nur das Verhalten im Falle von "wenig Inhalt" ein.
     * @param maxHeight Maximale Höhe, bevor der Resourcepicker scrollt
     * @param width fixed: die Breite ergibt sich aus dem Inhalt (Gruppenbreiten und Baseunits); fixedCentered: wie fixed, aber horizontal mittig ausgerichtet; fullwidth: Container und Picker wachsen auf volle Breite
     */
    setLayout(maxHeight: string = "unset", width: "fixed" | "fixedCentered" | "fullwidth" = "fixed") {

        if (maxHeight != null) {
            this.domNode.style.setProperty("--maxHeight", maxHeight);
        }

        if (width == "fullwidth") {
            this.UiModder.domStyle.set(this.tableContainer, "width", "unset");
        } else {
            if (width == "fixed") {
                this.UiModder.domStyle.set(this.tableContainer, "width", "");
                this.UiModder.domStyle.set(this.tableContainer, "margin", "");
            }
            else if (width == "fixedCentered") {
                this.UiModder.domStyle.set(this.tableContainer, "width", "");
                this.UiModder.domStyle.set(this.tableContainer, "margin", "auto");
            }

        }
    }

    private _setAllowDragAttr(value: boolean) {
        this.setAllowDrag(value);
    }
    private _dndConfig: dndConfig;

    setAllowDrag(value: boolean) {
        this.allowDrag = value;
    }

    setupDragAndDrop(config: dndConfig) {
        this._dndConfig = config;
        this.allowDrag = !!this._dndConfig;
        if (this.groupRegistry.length) {
            this._createTable();
        }
    }

    private _setMaxHeightAttr(maxHeight: string) {
        this.setLayout(maxHeight);
    }

    setTooltipClickFct(callback: Function) {
        this.tooltipCallback = callback;        
    }

    private _onGlobalClick(evt: MouseEvent) {
        // Achtung: nicht immer kommt hier wirklich das Event als erster Parameter.
        // es kann auch andere Widgets (floating tooltip) geben, die das auslösen und selber was mitgeben.
        // daher unbedingt abfragen, ob evt auch wirklich ein evt mit stopPropagation ist, ansonsten brauchen wirs nicht.

        this._showTooltip(null, false, "", null, evt?.stopPropagation ? evt : null);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.addSubscription("/Global/Click", lang.hitch(this, this._onGlobalClick));

        this.items = [];
        this.createdItemNodes = [];
        this.groupRegistry = [];
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(ResourcePicker);